const logoAssets = {
  // Abecma.
  'celltherapy360-logo.png': require('assets/CT360-LOGO-RBG_CT360.png'),
  'bms-logo.png': require('assets/bms_logo_rgb_pos_150.png'),
  // Pluvicto.
  'pluvicto_logo.png': require('assets/pluvicto_logo.png'),
  'aaa_logo.png': require('assets/aaa_logo_download.png'),
  // Cizplam Sales Demo site.
  'cizplam-logo.png' : require('assets/Cizplam_logo.png'),
  // Ventixal Sales Demo site.
  'ventixal-logo.png' : require('assets/ventixal_logo.png'),
  // Urolift.
  'urolift-logo.png': require('assets/UROLIFT_2c_GoldO_BKTAG.png'),
  'teleflex-logo.png': require('assets/Teleflex_Logo_BK.png'),
  // Astrazeneca Saphnelo NOC.
  'saphnelo-logo-rtm.png': require('assets/saphnelo-dosage-rtm-a360-logo.png'),
  // Astrazeneca Imjudo NOC.
  'imjudo-logo.png': require('assets/imjudo-a360.png'),
  // Multiple AZ sites - Note: ALL AZ sites share this image.
  'az-logo.png': require('assets/AZ-logo.png'),
  'az-logo-white.png': require('assets/astraZeneca.png'),
  // Danatech.
  'danatech-logo.png': require('assets/danatech_Logo_2022.png'),
  // Fasenra.
  'fasenra-logo.png': require('assets/FASENRA_R_logo_exUS_RGB_Icon_Left.jpg'),
  // Boston Scientific.
  'bostonscientific-logo.png': require('assets/BSC_wtag_541blue.png'),
  'watchman-logo.png': require('assets/PAL_Image_2158x477-600dpi.png'),
  // Aquablation
  'aquablation-logo.png': require('assets/Aquablation_Logo_RGB_Lockup_150.png'),
  'procept-biorobotics-logo.png': require('assets/PROCEPT_Logo_Solid_RGB_150.png'),
  // Triptodur
  'triptodur-logo.png': require('assets/triptodur-logo.png'),
  'azurity-logo.png': require('assets/azurity-logo-white.svg'),
  //Imfinzi + Imjudo
  'imfinzi-imjudo-access360.png': require('assets/imfinzi-imjudo-access360.png')
};

export default logoAssets;



// WEBPACK FOOTER //
// ./src/assets/assets.js